<div class="dialog-content">
  <div class="dialog-header">
    <span class="dialog-heading">
      <span *ngIf="importingData.action === 'Add'">Add a new organizational unit</span>
      <span *ngIf="importingData.action !== 'Add'">Edit organizational unit</span>
    </span>
    <mat-icon class="h-24-w-24 cursor-pointer" mat-dialog-close>close</mat-icon>
  </div>

  <ng-container *ngIf="importingData.action === 'Add'; else editBlock">
    <form #form="ngForm">
      <div class="wrapper">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Code</mat-label>
          <input name="code" matInput [(ngModel)]="unitData.code" required />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Name</mat-label>
          <input name="name" matInput [(ngModel)]="unitData.name" required />
        </mat-form-field>
      </div>
      <div class="action-button">
        <button
          class="primary-button"
          [disabled]="!form.valid || !isFormValid()"
          [promiseBtn]="adding"
          (click)="addNewUnitFromDialog()"
        >
          <mat-icon>add</mat-icon>
          <span class="ml-8">Add unit</span>
        </button>
      </div>
    </form>
  </ng-container>

  <ng-template #editBlock>
    <form #form="ngForm">
      <div class="wrapper">
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Code</mat-label>
          <input name="code" matInput [(ngModel)]="unitDataEdit.code" required />
        </mat-form-field>
        <mat-form-field appearance="outline" [hideRequiredMarker]="true">
          <mat-label>Name</mat-label>
          <input name="name" matInput [(ngModel)]="unitDataEdit.name" required />
        </mat-form-field>
      </div>
      <div class="action-button">
        <button
          class="primary-button"
          [disabled]="!form.valid || !isFormDirty() || !isFormValid()"
          [promiseBtn]="adding"
          (click)="editUnitFromDialog()"
        >
          <mat-icon>save</mat-icon>
          <span class="ml-8">Update unit</span>
        </button>
      </div>
    </form>
  </ng-template>
</div>
